import { combineReducers } from "redux";
import ForgetPassword from "./auth/forgetpwd/reducer";
// Authentication
import Login from "./auth/login/reducer";
import Profile from "./auth/profile/reducer";
import Account from "./auth/register/reducer";
//Dashboard
import Dashboard from "./dashboard/reducer";
//E-commerce
import ecommerce from "./e-commerce/reducer";
// Front
import Layout from "./layout/reducer";
//menu
import menu from "./menu/reducer";
//processUpload
import allocateRunner from "./allocate-runners/reducer";
import allocateShippingUnits from "./allocate-shipping-units/reducer";
import bus from "./bus/reducer";
import customer from "./customer/reducer";
import groupTransport from "./group-transport/reducer";
import importManagement from "./import-management/reducer";
import notificationManagement from "./notification-management/reducer";
import notification from "./notification/reducer";
import orderRunner from "./order-runners/reducer";
import orderManage from "./order/reducer";
import reportManagement from "./report-management/reducer";
import route from "./route/reducer";
import shippingUnit from "./shipping-unit/reducer";
import userProfile from "./user-profile/reducer";

const rootReducer = combineReducers({
  Layout,
  Login,
  Account,
  ForgetPassword,
  Profile,
  ecommerce,
  Dashboard,
  menu,
  notificationManagement,
  shippingUnit,
  customer,
  route,
  bus,
  reportManagement,
  userProfile,
  importManagement,
  allocateShippingUnits,
  allocateRunner,
  notification,
  orderRunner,
  orderManage,
  groupTransport,
});

export default rootReducer;
